// extracted by mini-css-extract-plugin
export default {"box":"index_box_KMhos","footer":"index_footer_1Miad","right_link":"index_right_link_DlDZ8","f_ico1":"index_f_ico1_wvhJi","v_dellink":"index_v_dellink_MAwXH"};